// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination-1Qhh_","page":"page-3jaEi","button":"button-TBqDc","more":"more-LY9Py","page_selected":"page_selected-D86nE","button_disabled":"button_disabled-ityH7"};